<template>
  <div class="nav flex items-center justify-between flex-wrap">
    <div class="flex item-center flex-shrink-0">
      <router-link
        :to="{ path: 'Home' }"
        class="font-extrabold text-black text-2xl"
      >
        DIMS.
      </router-link>
    </div>
    <div class="block lg:hidden">
      <button
        class="flex items-center px-3 py-2 border rounded text-white border-white-100 hover:text-white hover:border-white"
      >
        <svg
          class="fill-current h-3 w-3"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>Menu</title>
          <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
        </svg>
      </button>
    </div>
    <div class="w-full block lg:flex lg:items-center items lg:w-auto">
      <div class="lg:flex-grow font-medium text-base">
        <a
          target="_blank"
          href="https://github.com/dizzy1021"
          class="block mt-4 text-white lg:inline-block lg:mt-0 hover:text-gray-400 mr-10"
        >
          Projects
        </a>
        <a
          target="_blank"
          href="https://medium.com/@dimasadi_77243"
          class="block mt-4 text-white lg:inline-block lg:mt-0 hover:text-gray-400 mr-10"
        >
          Articles
        </a>
        <a
          href="mailto:dimasadiprananda@gmail.com"
          class="block mt-4 text-white lg:inline-block lg:mt-0 hover:text-gray-400"
        >
          Contact
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navigation"
};
</script>

<style lang="scss" scoped>
#menu-toggle:checked + #menu {
  display: block;
}
a {
  font-family: "Inter";
}
</style>
